import React, { useState } from 'react';
import { HelpCircle } from 'react-feather';

const InfoTooltip = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div 
            className="info-tooltip-container" 
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '8px', position: 'relative', cursor: 'help' }}
        >
            <HelpCircle size={16} color="#666" />
            {isVisible && (
                <div 
                    className="tooltip-content"
                    style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '8px',
                        padding: '8px 12px',
                        backgroundColor: '#333',
                        color: '#fff',
                        borderRadius: '4px',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        width: 'max-content',
                        maxWidth: '250px',
                        zIndex: 1000,
                        textAlign: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    {text}
                    <div 
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '50%',
                            marginLeft: '-5px',
                            borderWidth: '5px',
                            borderStyle: 'solid',
                            borderColor: '#333 transparent transparent transparent'
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default InfoTooltip;
